import { attr, belongsTo, hasMany } from '@warp-drive/legacy/model';

import Model from 'umg-ember-backend/models/variant-model';
import { buildValidations } from 'umg-ember-backend/utils/validations';

const Validations = buildValidations();

export const settings = {
  copyableOptions(record) {
    return {
      ignoreAttributes: [
        'channelsAdditive',
        'channelsExcluded',
        'channelsExclusive',
        'ownedByChannel',
      ],
      overwrite: {
        storyContents: record.storyContents.filter((contentItem) => {
          return contentItem.type !== 'newsletter';
        }),
      },
    };
  },
  variantProperties: [
    'cmsLanguageId',
    'seoTitle',
    'seoDescription',
    'seoImage',
    'cmsState',
    'headline',
    'teaserHeadline',
    'teaserSubHeadline',
    'text',
  ],
};

export default class StoryModel extends Model.extend(Validations) {
  @attr('string') headline;
  @attr() shops;
  @attr('story-content', {
    defaultValue() {
      return [];
    },
  })
  storyContents;
  @attr('string') text;
  @attr('string') teaserHeadline;
  @attr('string') teaserSubHeadline;

  // CMS fields
  @attr('number', { defaultValue: 2 }) cmsState;
  @attr('string') seoTitle;
  @attr('string') seoDescription;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @hasMany('artist', { async: true, inverse: null }) artists;
  @belongsTo('asset', { async: true, inverse: null }) seoImage;
  @hasMany('channel', { async: true, inverse: null }) channelsAdditive;
  @hasMany('channel', { async: true, inverse: null }) channelsExcluded;
  @hasMany('channel', { async: true, inverse: null }) channelsExclusive;
  @belongsTo('channel', { async: true, inverse: null }) ownedByChannel;

  // Getter and setter
  get displayHeadline() {
    return this.headline;
  }

  get displayLabel() {
    return `${this.headline} (${this.id})`;
  }
}
